class Main {
    isStartAtReady = false;
    detectScroll = null;
    handlerResize = [];
    mobileResolutionBorder = 768;
    configPC = null;
    configMobile = null;
    currentWindowWidth = null;
    fireResizeInProcess = false;
    loader = null;
    loaderTicks = 226;
    currentTick = 0;

    constructor() {
        window.language = document.documentElement.lang;
        this.currentWindowWidth = window.innerWidth;
        this.loader = document.getElementById('percent_loader');
        if (window.innerWidth < this.mobileResolutionBorder) this.loaderTicks = 21;
        this.setLoaderPercent(1);
        this.getAjaxContent();
    }

    getAjaxContent() {
        let urlParams = document.location.search;
        let x = null;
        if (urlParams.length) {
            urlParams = urlParams.slice(1).split('&');
            for (const param of urlParams) {
                const arrayParam = param.split('=');
                if (arrayParam[0].toLowerCase() === 'x') {
                    if (arrayParam[1].toString().length) x = arrayParam[1];
                    break;
                }
            }
        }

        const xhr = new XMLHttpRequest();
        xhr.open("GET", '/ajax/instaforex?language=' + window.language + (x !== null ? '&x=' + x : ''));
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.addEventListener("load", function () {
            if (xhr.status >= 200 && xhr.status < 400) {
                document.getElementById('ajax-target').innerHTML = xhr.response;
                this.setLoaderPercent(1);
                this.ready();
            }
        }.bind(this));
        xhr.send();
    }

    setLoaderPercent(number) {
        this.currentTick += number;
        this.loader.innerHTML = Math.round(this.currentTick / (this.loaderTicks / 100));
    }

    startAtReady() {
        if (this.isStartAtReady) return;
        this.isStartAtReady = true;
        this.setLoaderPercent(1);
        this.configPC = {
            'config': [//937
                {
                    start: 0,
                    end: '200vh',
                    position: 'top',
                    configName: welcomeObject.configName,
                    element: document.querySelector('.welcome'),
                    callback: welcomeObject.reactToScroll.bind(welcomeObject),
                    isShowed: true
                },
                {
                    start: '100vh',
                    end: '1000vh',
                    configName: handAnimationObject.configName,
                    element: document.querySelector('.hand-animation'),
                    callback: handAnimationObject.reactToScroll.bind(handAnimationObject)
                },
                {
                    start: '100vh',
                    end: '900vh',
                    configName: promoTextObject.configName,
                    element: document.querySelector('.promo-text'),
                    callback: promoTextObject.reactToScroll.bind(promoTextObject)
                },
                {
                    start: '910vh',
                    height: '+115vh',
                    configName: servicesObject.configName,
                    element: document.querySelector('.services__container'),
                    callback: servicesObject.reactToScroll.bind(servicesObject)
                },
                {
                    start: '-95vh',
                    height: '500vh',
                    isHasEnd: false,
                    configName: accountObject.configName,
                    element: document.querySelector('.account'),
                    callback: accountObject.reactToScroll.bind(accountObject)
                },
                {
                    start: '-100vh',
                    isHasEnd: false,
                    configName: footerObject.configName,
                    element: document.querySelector('.footer__wrapper'),
                    callback: footerObject.reactToScroll.bind(footerObject)
                },
            ]
        };

        this.configMobile = {
            'config': [
                {
                    start: 0,
                    position: 'top',
                    configName: welcomeObject.configName,
                    element: document.querySelector('.welcome'),
                    callback: welcomeObject.reactToScroll.bind(welcomeObject),
                    isShowed: true
                },
                {
                    configName: handAnimationObject.configName,
                    element: document.querySelector('.hand-animation'),
                    callback: null,
                    isShowed: true
                },
                {
                    configName: promoTextObject.configName,
                    element: document.querySelector('.promo-text'),
                    callback: null,
                    isShowed: true
                },
                {
                    configName: servicesObject.configName,
                    element: document.querySelector('.services__container'),
                    callback: null,
                    isShowed: true
                },
                {
                    configName: accountObject.configName,
                    element: document.querySelector('.account'),
                    callback: accountObject.reactToScroll.bind(accountObject),
                    isShowed: true,
                    isHasEnd: true
                },
                {
                    configName: footerObject.configName,
                    element: document.querySelector('.footer__wrapper'),
                    callback: null,
                    isShowed: true,
                    isHasEnd: true
                },
            ]
        };

        this.detectScroll = new DetectScroll(this.configPC);

        welcomeObject.initialize();

        if (window.innerWidth >= this.mobileResolutionBorder) {
            riveHeaderAnimationObject.initialize();
            promoTextObject.initialize();
            handAnimationObject.initialize();
            riveHandObject.initialize();
            footerObject.initialize();
        }

        accountObject.initialize(); //Нужен для мобильной версии
        riveAccountObject.initialize(); //Нужен для мобильной версии
    }

    ready() {
        this.startAtReady();

        if (
            (window.innerWidth < this.mobileResolutionBorder && (
                riveAccountObject.status !== 1
            ))
            || (window.innerWidth >= this.mobileResolutionBorder && (
                riveHeaderAnimationObject.status !== 1
                || handAnimationObject.status !== 1
                || riveHandObject.status !== 1
                || animationPlayerObject.status !== 1
                || riveAccountObject.status !== 1
            ))
        ) {
            setTimeout(this.ready.bind(this), 500);
            return;
        }

        document.body.classList.remove('_wait');
        document.body.classList.add('_loaded');

        setTimeout(() => {
            if (riveHeaderAnimationObject.status === 1) {
                riveHeaderAnimationObject.instance.canvas.style.opacity = '';
                riveHeaderAnimationObject.play();
            }
        }, 1000);

        this.setLoaderPercent(1);
        setTimeout(this.afterEndAnimationLoad.bind(this), 3500);
    }

    afterEndAnimationLoad() {
        //document.body.setAttribute('style', '');
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('_loaded');

        let elements = document.getElementsByClassName('header-container');
        for (let i = 0, size = elements.length; i < size; i++) {
            // noinspection JSUnresolvedVariable
            elements[i].style.paddingRight = '';
        }

        elements = document.getElementsByClassName('block-content');
        for (let i = 0, size = elements.length; i < size; i++) {
            // noinspection JSUnresolvedVariable
            elements[i].style.marginRight = '';
        }

        window.addEventListener('resize', this.fireResize.bind(this));

        this.detectScroll.init();
        welcomeObject.reactToResize();
        if (window.innerWidth >= this.mobileResolutionBorder) {
            handAnimationObject.reactToResize();
            servicesObject.initialize();
        } else {
            main.detectScroll.settings.config = this.configMobile.config;
            main.detectScroll.compileConfig();
        }
        languageObject.initialize(); //Нужен для мобильной версии
    }

    fireResize() {
        if (this.currentWindowWidth === window.innerWidth && !this.fireResizeInProcess) return;

        this.currentWindowWidth = window.innerWidth;
        this.fireResizeInProcess = true;

        setTimeout(function () {
            if (window.innerWidth < this.mobileResolutionBorder) {
                this.detectScroll.settings.config = this.configMobile.config;
            } else {
                this.detectScroll.settings.config = this.configPC.config;

                if (welcomeObject.status < 0) welcomeObject.initialize();
                if (riveHeaderAnimationObject.status < 0) riveHeaderAnimationObject.initialize();
                if (promoTextObject.status < 0) promoTextObject.initialize();
                if (handAnimationObject.status < 0) handAnimationObject.initialize();
                if (riveHandObject.status < 0) riveHandObject.initialize();
                if (servicesObject.status < 0) servicesObject.initialize();
                if (footerObject.status < 0) footerObject.initialize();

                if (
                    welcomeObject.status !== 1
                    || riveHeaderAnimationObject.status !== 1
                    || promoTextObject.status !== 1
                    || handAnimationObject.status !== 1
                    || riveHandObject.status !== 1
                    || servicesObject.status !== 1
                    || footerObject.status !== 1
                ) {
                    this.fireResize();
                    return;
                }
            }

            this.detectScroll.compileConfig();
            if (welcomeObject.status === 1) welcomeObject.reactToResize()
            if (promoTextObject.status === 1) promoTextObject.reactToResize();
            if (handAnimationObject.status === 1) handAnimationObject.reactToResize();
            if (servicesObject.status === 1) servicesObject.reactToResize();
            if (accountObject.status === 1) accountObject.reactToResize();
            if (riveAccountObject.status === 1) riveAccountObject.reactToResize();
            if (footerObject.status === 1) footerObject.reactToResize();

            riveHeaderAnimationObject.instance.canvas.style.opacity = '';
            riveHeaderAnimationObject.play();

            const dataWelcome = this.detectScroll.getSingleScrollData(welcomeObject.configName);
            this.detectScroll.checkElements(dataWelcome);

            this.fireResizeInProcess = false;
        }.bind(this), 200);
    }
}

window.main = new Main();
